import updateStreakDisplay from '../utils/updateStreakDisplay';

const Stats = {
  sendStats: async function (
    gameKey: string,
    gameDate: string,
    gameId: string,
    level: string,
    gameResult: string,
    stats: any,
  ): Promise<void> {
    const apiBaseUrl = window.HeyGoodGame.config.apiBaseUrl;
    const accessToken = localStorage.getItem('heygg_jwt');
    const anonymousId = localStorage.getItem('heygg_anonymous_id');

    const headers: { 'Content-Type': string; Authorization?: string } = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    const body: {
      game_key: string;
      game_date: string;
      game_id: string;
      game_result: string;
      stats: any;
      anonymous_id?: string;
    } = {
      game_key: gameKey,
      game_date: gameDate,
      game_id: gameId,
      game_result: gameResult,
      stats: { level, ...stats },
    };

    if (!accessToken && anonymousId) {
      body.anonymous_id = anonymousId;
    }

    try {
      const response = await fetch(`${apiBaseUrl}/api/game-stats`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Failed to send stats');
      }

      await updateStreakDisplay(gameKey, level);
    } catch (err) {
      throw err;
    }
  },
  sendHistoryStats: async function (
    gameKey: string,
    level: string,
    stats: any,
  ): Promise<void> {
    const apiBaseUrl = window.HeyGoodGame.config.apiBaseUrl;
    const accessToken = localStorage.getItem('heygg_jwt');
    const anonymousId = localStorage.getItem('heygg_anonymous_id');

    if (!accessToken && !anonymousId) {
      return;
    }

    const headers: { 'Content-Type': string; Authorization?: string } = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    const body: {
      game_key: string;
      level: string;
      stats: any;
      anonymous_id?: string;
    } = {
      game_key: gameKey,
      level: level,
      stats: stats,
    };

    if (!accessToken && anonymousId) {
      body.anonymous_id = anonymousId;
    }

    try {
      const response = await fetch(`${apiBaseUrl}/api/historical-stats`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to send stats');
      }

      await response.json();
    } catch (err) {
      throw err;
    }
  },
  getGameStatsById: async function (
    gameKey: string,
    gameId: string,
  ): Promise<any[]> {
    const apiBaseUrl = window.HeyGoodGame.config.apiBaseUrl;
    const accessToken = localStorage.getItem('heygg_jwt');

    if (!accessToken) {
      return [];
    }

    const headers: { 'Content-Type': string; Authorization?: string } = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    // Build the URL
    let url = `${apiBaseUrl}/api/game-stats/${gameKey}/${gameId}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`Failed to get stats: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      console.error('Error fetching game stats:', err);
      throw err;
    }
  },
  getUserStats: async function (
    gameKey: string,
    level: string | undefined,
  ): Promise<any> {
    const apiBaseUrl = window.HeyGoodGame.config.apiBaseUrl;
    const accessToken = localStorage.getItem('heygg_jwt');

    if (!accessToken) {
      return;
    }

    const headers: { 'Content-Type': string; Authorization?: string } = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    let url = `${apiBaseUrl}/api/user-stats?game_key=${gameKey}`;

    if (level) {
      url += `&level=${level}`;
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`Failed to get stats: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      console.error('Error fetching game stats:', err);
      throw err;
    }
  },
};

export default Stats;
